import {
  IDocumentTypeOption,
  IPrefilledAttachment,
} from 'Hooks/useDocumentUpload';
import { DocumentUploadProvider } from '../../../../Context/DocumentUploadContext';
import { DocumentUpload } from './DocumentUpload';
import { DeleteToast } from './DeleteToast';
import { DeleteConfirmationModal } from './DeleteConfirmationModal';
import { FilePreviewModal } from './FilePreviewModal';

export interface IDocumentUploadManager {
  availableDocumentTypes: IDocumentTypeOption[];
  onUploadComplete?: (documentTypes: any[]) => void;
  prefilledAttachment?: IPrefilledAttachment;
}

export const DocumentUploadManager = ({
  availableDocumentTypes,
  onUploadComplete,
  prefilledAttachment,
}: IDocumentUploadManager) => {
  return (
    <DocumentUploadProvider
      availableDocumentTypes={availableDocumentTypes}
      onUploadComplete={onUploadComplete}
      prefilledAttachment={prefilledAttachment}
    >
      <DocumentUpload />
      <DeleteToast />
      <DeleteConfirmationModal />
      <FilePreviewModal />
    </DocumentUploadProvider>
  );
};
